<template>
    <div>
        <MemberTalkScheduleDetail :scheduleIdx="scheduleIdx" :isOpen="isOpenScheduleDetail" :closeCompleteAction="close"></MemberTalkScheduleDetail>
    </div>
</template>

<script>
    import MemberTalkScheduleDetail from "./MemberTalkScheduleDetail";
    export default {
        name: "MemberTalkScheduleDetailModalWrap",
        components: {MemberTalkScheduleDetail},
        props : {
            scheduleIdx : {
                type : [Number, String],
                default : -1,
            }
        },
        data(){
            return {
                isOpenScheduleDetail : false,
            }
        },
        methods : {
            close(){
                if(this.isOpenScheduleDetail) {
                    this.isOpenScheduleDetail = false;
                    return;
                }
                setTimeout(() => {
                    this.$GlobalStore.closeLastModal();
                }, 300)
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.isOpenScheduleDetail = true;
            })

        },
        created(){

        }
    }
</script>

<style scoped>

</style>